import { render, staticRenderFns } from "./person-info.html?vue&type=template&id=6745184d&scoped=true&external"
import script from "./person-info.js?vue&type=script&lang=js&external"
export * from "./person-info.js?vue&type=script&lang=js&external"
import style0 from "./person-info.scss?vue&type=style&index=0&id=6745184d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745184d",
  null
  
)

export default component.exports